import { passwordStrength } from '../utils/password'

export function PasswordStrengthBar({ password }: { password: string }) {
  const score = passwordStrength(password)
  const colors = ['bg-red-500', 'bg-orange-500', 'bg-yellow-500', 'bg-green-400', 'bg-green-600']
  const labels = ['', 'Weak', 'Fair', 'Good', 'Strong']
  return (
    <div className="mt-1">
      <div className="flex gap-1 h-1.5">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className={`flex-1 rounded ${i <= score ? colors[score] : 'bg-gray-200'}`}
          />
        ))}
      </div>
      {password && (
        <p className="text-xs text-gray-500 mt-0.5">{labels[score]}</p>
      )}
    </div>
  )
}
